
import { getEntireSlice as getEntireSliceCommon } from './higherOrderFunctions'
import { REDUCER_NAMES_ENTITIES, REDUCER_NAMES_ENTITIES_CUSTOMER_MESSAGES as defaultSlice } from '../../constants'

// eslint-disable-next-line import/prefer-default-export
export const getEntireSlice = getEntireSliceCommon(REDUCER_NAMES_ENTITIES, defaultSlice)
